// Copyright 2024 praveen.konathala
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { RootState } from 'src/app/store';

export const selectBrands = (state: RootState) => state.appData.brands;
export const selectBrandsAsList = (state: RootState) => state.appData.brandsAsList;
export const selectIsInit = (state: RootState) => state.appData.isinit;
export const selectBrandConfig = (state: RootState) => state.appData.brandsConfig;
export const selectNmsDashConfig = (state: RootState) => state.appData.nmsdashConfig;
export const selectLocationConfig = (state: RootState) => state.appData.locationConfig;
export const selectBrandSecurity = (state: RootState) =>
  state.appData.brandsSecurity;
export const selectLocationSecurity = (state: RootState) =>
  state.appData.locationSecurity;
export const selectServicerAppSecurity = (state: RootState) =>
  state.appData.servicerAppSecurity;
export const selectLocations = (state: RootState) => state.appData.locations;
export const selectLocationsAsList = (state: RootState) => state.appData.locationsAsList;
export const selectUserProfile = (state: RootState) => state.auth.user;
export const selectReport = (state: RootState) => state.appData.selectedMenu;
export const selectTile = (state: RootState) =>
  state.appData.selectedReportTile;
export const selectSideMenuWidth = (state: RootState) =>
  state.appData.sideMenuWidth;
export const selectInitLoader = (state: RootState) => state.appData.isinit;
export const selectAlerts = (state: RootState) => state.appData.nmsdashAlert;
export const selectAlertsAsList = (state: RootState) => state.appData.nmsAlertAsList;
